import CustomView, {CustomViewData} from "../../custom-view"
import {ViewType} from "../../../../gd/const/views/view-type"
import ExpenseFields from "../../../expenses/expense/fields"
import ViewSettingsV2 from "../../../view-settings-v2/settings"
import viewExpenses_convertOldSettingsToV2 from "./actions/convert-settings"

export type ViewExpensesData = Omit<CustomViewData, "type">

// const debug = "ViewExpenses"
const debug = false

export default class ViewExpenses extends CustomView {

    constructor(data:ViewExpensesData) {
        const customViewData : CustomViewData = data as unknown as CustomViewData
        customViewData.type = ViewType.CUSTOM_VIEW_EXPENSES

        super(customViewData)

        /**--- Test purposes only [START] ---**/
        /*data.settings = {
            projects: [
                "BDHxMF"
            ],
            users: [
                "9V5f4g"
            ],
            startDate: "2024-11-26T21:00:00.000Z",
            endDate: "2024-11-27T21:00:00.000Z"
        }*/
        /**--- Test purposes only [END] ---**/

        if (!data.settings?.version) {
            data.settings = viewExpenses_convertOldSettingsToV2(data.settings)
        }

        debug && console.log(debug, "constructor", data, gd.fields)

        this.settings = new ViewSettingsV2(data.settings)
    }

    get conditionFieldsCollection():ExpenseFields {
        return gd.fields.expense
    }

    applyDelta(data:any) {
        let isChanged = super.applyDelta(data)

        _.mapKeys(data, (value ,key)=>{
            switch (key) {
                case 'settings':
                    this.settings = new ViewSettingsV2(value)
                    isChanged = true
                    break
            }
        })

        return isChanged
    }

    _initSettings(data:any) {
        super._initSettings(data)
        debug && console.log(debug, "._initSettings", data)

        this.settings = new ViewSettingsV2(data.settings)
    }

    generateRequestPayload(): any {
        return {
            endpoint 	: 'expenses',
            conditions 	: this.settings.conditions.toJSON({addCustomFieldConfig: true})
        }
    }
}
